import { trigger, style, transition, animate } from '@angular/animations';

export const cardAnimations = [
  trigger(
    'slidetoRightTransition', [
    transition(':enter', [
      style({ transform: 'translateX(-100%)', opacity: 1 }),
      animate('.5s', style({ transform: 'translateX(0%)', opacity: 1 }))

    ])
  ]
  ),
  trigger(
    'slidetoLeftTransition', [
    transition(':enter', [
      style({ transform: 'translateX(100%)', opacity: 0 }),
      // animate('.5s', style({ transform: 'translateX(0%)', opacity: 0 })),
      //animate('100ms 0.1s ease-in')
      animate('1000ms 0.1s ease-in')

    ])
  ]
  ),
  trigger(
    'slidetoBottomTransition', [
    transition(':enter', [
      style({ transform: 'translateY(-100%)', opacity: 0 }),
      // animate('.5s', style({ transform: 'translateX(0%)', opacity: 0 })),
      animate('0.7s 500ms ease-in')

    ])
  ]
  ),
  trigger(
    'slidetoTopTransition', [
    transition(':enter', [
      style({ transform: 'translateY(50%)', opacity: 0 }),
      // animate('.5s', style({ transform: 'translateX(0%)', opacity: 0 })),
      animate('0.2s 500ms ease-in')

    ])
  ]
  ),
  trigger('Grow', [
    transition(':enter', [  
      style({height:'0'}),
      animate(500, style({height:'*'})) 
    ]),
    transition(':leave', [   
      animate(500, style({height:0})) 
    ])
    ])
 
];

